import { AxiosError } from 'axios';
import axiosClient from '../axiosClient';
import { POST_GROUP_AMENDMENT_SEARCH_URL } from '../../constants/apiUrls';
import { useCustomMutation } from '../utils/useCustomMutation';
import { GenericErrorResponse } from '../typings';
import { PaginatedData } from '../../models/List';
import { ApiPathParam } from '../../models/SearchParamSchema';

interface SearchGroupAmendmentsRequest {
  q?: string;
  pathParams: ApiPathParam;
}

export interface SearchGroupAmendmentsResponse {
  uuid: string;
  applicationId: string;
  candidateId: string;
  candidateName: string;
  examLevels: string[];
  applicationDateTime: string;
  status: string;
  windowOpened: boolean;
}

interface Input {
  onSuccess?: (data: PaginatedData<SearchGroupAmendmentsResponse>) => void;
  onError?: (data: AxiosError<GenericErrorResponse>) => void;
  onSettled?: () => void;
}

export const usePostSearchGroupAmendments = ({ onSuccess, onError, onSettled }: Input) => {
  const postSearchSubjectAmendments = async (payload: SearchGroupAmendmentsRequest) => {
    const res = await axiosClient.post<PaginatedData<SearchGroupAmendmentsResponse>>(
      POST_GROUP_AMENDMENT_SEARCH_URL(payload.pathParams),
      { q: payload.q },
      { timeout: 30000 }
    );
    return res.data;
  };

  return useCustomMutation(postSearchSubjectAmendments, {
    onSuccess,
    onError,
    onSettled,
  });
};
